import { debounce } from 'app/utilities/utils';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DEFAULT_PAGE_INDEX } from '../constants/global';
import { getSearchParameters } from '../utilities/url';
import { PaginationHookInterface } from './types';

const usePagination: PaginationHookInterface = ({
  hasNext,
  fetchCallback,
  dependency,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [pageNumber, setPageNumber] = useState<number>(DEFAULT_PAGE_INDEX);
  const previousPageNumber = useRef(null);

  useEffect(() => {
    const currentPageNumber = Number(
      searchParams.get('pageNumber') ?? DEFAULT_PAGE_INDEX
    );
    if (
      previousPageNumber?.current &&
      previousPageNumber?.current === currentPageNumber
    ) {
      handlePageChange(null, DEFAULT_PAGE_INDEX);
    } else {
      fetchCallback();
    }

    previousPageNumber.current = currentPageNumber as any;
    setPageNumber(currentPageNumber);
  }, [searchParams, dependency]);

  const handlePageChange = (event: any, newPage: number) => {
    const currentPage = pageNumber;
    if (currentPage === newPage) {
      fetchCallback();
    } else if ((newPage > currentPage && hasNext) || newPage < currentPage) {
      setPageNumber(newPage);
      const currentSearchParams = getSearchParameters(searchParams);
      setSearchParams({
        ...currentSearchParams,
        pageNumber: newPage.toString(),
      });
    }
  };

  const debouncedHandlePageChange = debounce((e?: any, newPage?: number) => {
    if (typeof newPage === 'number' && Number.isInteger(newPage))
      return handlePageChange(e, newPage);
  }, 300);

  return {
    page: pageNumber,
    handlePageChange: debouncedHandlePageChange,
  };
};

export default usePagination;
